import { LeaderboardDefaultAvatar } from '../../svgs/gfm_leaderboard';
import SvgLeaderboardFirstBadge from '../../svgs/gfm_leaderboard/LeaderboardFirstBadge';
import SvgLeaderboardSecondBadge from '../../svgs/gfm_leaderboard/LeaderboardSecondBadge';
import SvgLeaderboardThirdBadge from '../../svgs/gfm_leaderboard/LeaderboardThirdBadge';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Get full name from user object
 */
export const getFullName = organizer => `${organizer.firstName} ${organizer.lastName}`.trim();

/**
 * Get default avatar URL when profileUrl is null
 */
export const getDefaultAvatar = () => /*#__PURE__*/_jsx(LeaderboardDefaultAvatar, {});

/**
 * Get rank icon for top 3 positions
 */
export const getRankIcon = rank => {
  switch (rank) {
    case 1:
      return /*#__PURE__*/_jsx(SvgLeaderboardFirstBadge, {});
    case 2:
      return /*#__PURE__*/_jsx(SvgLeaderboardSecondBadge, {});
    case 3:
      return /*#__PURE__*/_jsx(SvgLeaderboardThirdBadge, {});
    default:
      return null;
  }
};

/**
 * Get background color for rank position
 */
export const getRankBackgroundColor = rank => {
  switch (rank) {
    case 1:
      return '#CCF88E';
    // Green
    case 2:
      return '#A7E3E3';
    // Blue
    case 3:
      return '#FFD863';
    // Yellow
    default:
      return '#FFF';
    // White
  }
};

/**
 * Transform API data to component-friendly format
 */
export const transformLeaderboardData = edges => edges.map(({
  node
}) => ({
  id: node.id,
  rank: node.rank + 1,
  // Convert from 0-based to 1-based ranking
  name: getFullName(node.fundraiser.organizer),
  profileImage: node.fundraiser.organizer.profileUrl,
  campaignTitle: node.fundraiser.title,
  amountRaised: node.fundraiser.currentAmount.amount,
  currencyCode: node.fundraiser.currentAmount.currencyCode,
  slug: node.fundraiser.slug
}));
export const getGfmBaseUrl = gfmBaseUrl => {
  if (!gfmBaseUrl) {
    throw new Error('GFM Base URL is required');
  }

  // if it doesn't start with https:// - throw error
  if (!gfmBaseUrl.startsWith('https://')) {
    throw new Error('GFM Base URL must start with "https://"');
  }
  const url = new URL(gfmBaseUrl);
  return `${url.protocol}//${url.host}${url.pathname.replace(/\/$/, '')}`;
};
export function getStartFundraisingUrl(siteBaseUrl, campaignId) {
  // if ends with a slash, don't add another one
  if (siteBaseUrl.endsWith('/')) {
    return `${siteBaseUrl}campaign/${campaignId}/startfundraising`;
  }
  return `${siteBaseUrl}/campaign/${campaignId}/startfundraising`;
}